import { Record } from "immutable";

const AdditionChoiceRecord = Record({
  id: null,
  order: "",
  // 追加
  label: ""
});

class AdditionChoice extends AdditionChoiceRecord {}

export default AdditionChoice;



// WEBPACK FOOTER //
// ./src/models/AdditionChoice.js